import React from "react";
import Sticky from "react-stickynode";
import PasajesSection from "./pasajesSection";
import HotelSection from "./hotelSection";
import TransferSection from "./transferSection";
import TituloSection from "./tituloSection";
import PreciosSection from "./preciosSection";
import TotalSection from "./totalSection";
import HabitacionesSection from "./habitacionesSection";

//FC: stateless componente (sin estado, solo con props)
const FichaReserva = (props) => {
  const {
    charter,
    producto,
    totalPaquete,
    tarifaNeta,
    totalPaqueteConPlanFamily,
    cargosAdministrativos,
    totalSeguroCancelacion,
    puntosDeEmbarques,
    pasajerosPagantes,
    infoas,
    pasajerosAdultos,
    pasajerosMenores,
    impuestos,
    tarifaPorHabitacion
  } = props;

  /*const totalPlanFamilyNeto = calcularFamilyPlanNeto(props.producto, props.charter, props.pasajerosAdultos, props.pasajerosMenores);
  const infoas = despejarInfoas(props.pasajerosMenores);//function en Tools
  const totalTasasDeInfoas = infoas * props.producto.importeDeInfoa;
  const pasajerosPagantes = props.pasajerosAdultos.length + props.pasajerosMenores.length - infoas;*/

  //const totalAdicionalPorDia = (props.charter.tarifa.adicionalPorDia * props.pasajerosPagantes * props.producto.moneda.cotizacion).toLocaleString();
  /*const tarifaNeta = Math.round((((props.charter.tarifa.tarifaNeta - (props.charter.tarifa.tarifaNeta * (props.charter.promoValijaYa / 100)))) + props.charter.tarifa.adicionalPorDia) * pasajerosPagantes * props.producto.moneda.cotizacion).toLocaleString();
  const cargosAdministrativos = Math.round(props.producto.gastoDeReserva.importe * pasajerosPagantes * props.producto.moneda.cotizacion);
  const impuestos = Math.round((((props.charter.tarifa.tarifa - (props.charter.tarifa.tarifa * (props.charter.promoValijaYa / 100)))
                 - (props.charter.tarifa.tarifaNeta - (props.charter.tarifa.tarifaNeta * (props.charter.promoValijaYa / 100))))
                 * pasajerosPagantes * props.producto.moneda.cotizacion) + totalTasasDeInfoas);
  const totalPaquete = Math.round((((props.charter.tarifa.tarifa - (props.charter.tarifa.tarifa * (props.charter.promoValijaYa / 100)) + props.producto.gastoDeReserva.importe)) + props.charter.tarifa.adicionalPorDia) * pasajerosPagantes * props.producto.moneda.cotizacion).toLocaleString();
  const totalPaquetePlanFamily = calcularFamilyPlan(props.producto, props.charter, props.pasajerosAdultos, props.pasajerosMenores);*/

  return (
    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12 aside">
      <Sticky enabled={true} top={0} innerZ="99">
        <div className="sidebar">
          <div className="heading sidebar__inner">
            <TituloSection
              producto={producto}
              pasajerosAdultos={pasajerosAdultos}
              pasajerosMenores={pasajerosMenores}
              totalPaqueteConPlanFamily={totalPaqueteConPlanFamily}
            />
            {totalPaqueteConPlanFamily > 0 ? null : (
              <PreciosSection
                tarifaNeta={tarifaNeta}
                cargosAdministrativos={cargosAdministrativos}
                impuestos={impuestos}
                moneda={producto.moneda.simbolo}
                totalSeguroCancelacion={totalSeguroCancelacion}
              />
            )}
            <TotalSection
              pasajerosPagantes={pasajerosPagantes}
              totalPaquete={totalPaquete}
              infoas={infoas}
              moneda={producto.moneda.simbolo}
              cargosAdministrativos={cargosAdministrativos}
              totalPaqueteConPlanFamily={totalPaqueteConPlanFamily}
            />
          </div>
        </div>
      </Sticky>
      <div id="accordion" className="acordion">
        {producto.destino.idDestino !== "LMG" && (
          <PasajesSection
            transporte={producto.transporte}
            puntosDeEmbarques={puntosDeEmbarques}
            fechaSalida={charter.fechaSalida}
          />
        )}
        {producto.destino.idDestino !== "LMG" && (
          <HotelSection producto={producto} charter={charter} />
        )}
        {
          tarifaPorHabitacion && (
            <HabitacionesSection habitaciones={charter.habitacionesElegidas} />
          )
        }
        {producto.transfer && <TransferSection producto={producto} />}
      </div>
    </div>
  );
};

export default FichaReserva;



// WEBPACK FOOTER //
// ./src/components/ProcesoCompra/FichaReserva/index.js